import React, { useState } from 'react';
import { Alert } from '@mui/material';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import Menu from '../../components/Menu';
import {
    useContractDetail,
    useContractDetailData,
} from '../../../contextsProperty/ContextContractDetail';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    doubleLG_ColumnGrid,
    gridSpacing20,
    gridSpacing30,
} from '../../../../utils/commonVariables/grid';
import Card from '../../../../muiComponents/Card';
import Title from '../../../components/Title';
import Button from '../../../../muiComponents/Button';
import { ContractDetailPanelNames } from '../../../../types/contracts/contractTypes';
import CancellationPolicyPanel from './panels/CancellationPolicyPanel';
import DeletePopUp from './DeletePopUp';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import LoadingSection from './LoadingSection';
import useUserProfile from '../../../../customHooks/useUserProfile';

const CancellationPolicies = () => {
    const translate = useTranslate();
    const { setErrorMessage, setSuccessMessage } = useNotification();
    const { readOnlyUser } = useUserProfile();

    const {
        isMainInfoEmpty,
        isBlockedContract,
        handleOpenPanel,
        handleOpenCancellationPoliciesPanel,
        openedPanel,
        handleSaveCancellationPolicy,
        handleLoadingView,
        isLoadingView,
    } = useContractDetail();
    const { policies } = useContractDetailData();
    const [deletePopUpVisible, setDeletePopUpVisible] = useState('');

    const handleCloseCancellationPolicyPanel = () => {
        handleOpenPanel(null);
    };

    return (
        <>
            {deletePopUpVisible && !readOnlyUser && (
                <DeletePopUp
                    open={!!deletePopUpVisible}
                    onSave={async () => {
                        const deletedPolicy = policies.find(
                            policy => policy.id === deletePopUpVisible
                        );
                        if (!deletedPolicy) return;
                        try {
                            handleLoadingView(true);
                            await handleSaveCancellationPolicy({
                                ...deletedPolicy,
                                Deleted: true,
                            });
                            setSuccessMessage(
                                FeedbackMessages.COMMON_SUCCESS_DELETE
                            );
                        } catch (error) {
                            setErrorMessage(FeedbackMessages.COMMON_ERROR);
                        } finally {
                            handleLoadingView(false);
                            setDeletePopUpVisible('');
                        }
                    }}
                    onCancel={() => {
                        setDeletePopUpVisible('');
                    }}
                ></DeletePopUp>
            )}
            {openedPanel === ContractDetailPanelNames.CANCELLATION_POLICIES && (
                <CancellationPolicyPanel
                    open={
                        openedPanel ===
                        ContractDetailPanelNames.CANCELLATION_POLICIES
                    }
                    onClose={handleCloseCancellationPolicyPanel}
                />
            )}
            <section className='contract-detail__section'>
                <div className='flex-between flex-align-center'>
                    <SectionTitle text={'cancellation_policies'} />
                    {!isMainInfoEmpty && (
                        <Menu
                            menuItems={[
                                {
                                    text: 'add',
                                    icon: 'Add',
                                    disabled: isBlockedContract || readOnlyUser,
                                    onClick: () => {
                                        handleOpenCancellationPoliciesPanel({
                                            __isAdded: true,
                                            __isChanged: true,
                                        });
                                    },
                                },
                            ]}
                        />
                    )}
                </div>
                {isLoadingView ? (
                    <LoadingSection />
                ) : policies.length ? (
                    <Grid
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing20}
                        style={{ width: 'auto' }}
                    >
                        {policies?.map(policy => (
                            <GridChild
                                key={policy.id}
                                gridProps={doubleLG_ColumnGrid}
                            >
                                <Card
                                    key={policy.id}
                                    className=' flex-column gap-20'
                                    style={{ padding: '30px 25px' }}
                                >
                                    <div className='flex-between'>
                                        <Title key={policy.id}>
                                            {policy.name}
                                        </Title>
                                        <div className='flex-align-center gap-20'>
                                            <Menu
                                                menuItems={[
                                                    {
                                                        text: readOnlyUser
                                                            ? 'view'
                                                            : 'edit',
                                                        icon: readOnlyUser
                                                            ? 'Visibility'
                                                            : 'Edit',
                                                        onClick: () => {
                                                            handleOpenCancellationPoliciesPanel(
                                                                {
                                                                    __isAdded:
                                                                        false,
                                                                    __isChanged:
                                                                        true,
                                                                    ...policy,
                                                                }
                                                            );
                                                        },
                                                    },
                                                    {
                                                        text: 'delete',
                                                        icon: 'Delete',
                                                        disabled:
                                                            isBlockedContract ||
                                                            readOnlyUser,
                                                        onClick: () => {
                                                            setDeletePopUpVisible(
                                                                policy.id
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <p className='multiline-overflow__3'>
                                        {policy.content}
                                    </p>
                                </Card>
                            </GridChild>
                        ))}
                    </Grid>
                ) : (
                    <Card
                        className='contract-card__empty flex-center width100perc'
                        style={{ minHeight: '150px', padding: '10px 20px' }}
                    >
                        {isMainInfoEmpty ? (
                            <Alert severity='info' sx={{ width: '100%' }}>
                                {translate('add_main_info_first')}
                            </Alert>
                        ) : (
                            <Button
                                startIcon='Add'
                                disabled={readOnlyUser}
                                onClick={() => {
                                    handleOpenCancellationPoliciesPanel({
                                        __isAdded: true,
                                        __isChanged: true,
                                    });
                                }}
                            >
                                {translate('add')}
                            </Button>
                        )}
                    </Card>
                )}
            </section>
        </>
    );
};

export default CancellationPolicies;
